// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-content.request-track-table .searchDate .date-range input {
  padding: 6px 10px;
  border: 1px solid lightgray;
  border-radius: 3px;
  width: 140px;
}

.react-datepicker-wrapper {
  width: auto;
}

/* Fix calendar transparency and visibility */
.react-datepicker {
  background-color: #fff !important;
  border: 1px solid #aeaeae !important;
  z-index: 9999 !important;
}

.react-datepicker__header {
  background-color: #f0f0f0 !important;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}

.table-content.request-track-table
  .request-table-content
  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,
.request-box-info
  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  width: 0px;
}

.table-content.request-track-table
  .request-table-content
  .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-inputSizeSmall.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,
.request-box-info
  .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-inputSizeSmall.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  opacity: 0;
}

.table-content.request-track-table
  .request-table-content
  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon,
.request-box-info
  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
  left: 0;
}

.table-content.request-track-table
  .request-table-content
  .MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline,
.request-box-info
  .MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  border: none;
}

.request-box-info
  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
  top: 5px;
}

/* @import url("https://fonts.googleapis.com/css?family=Inter:400'"); */
/* html {
  background-color: #1a1a1a;
  overflow: hidden;
} */

.doctor-container .middle {
  width: 100%;
  text-align: center;
  /* Made by */
}
.doctor-container .middle h1 {
  font-family: "Inter", sans-serif;
  color: #fff;
}
.doctor-container .middle input[type="radio"] {
  display: none;
}
.doctor-container .middle input[type="radio"]:checked + .box {
  background-color: #007e90;
}
.doctor-container .middle input[type="radio"]:checked + .box span {
  color: white;
  transform: translateY(70px);
}
.doctor-container .middle input[type="radio"]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.doctor-container .middle .box {
  width: 200px;
  height: 200px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-family: "Inter", sans-serif;
  font-weight: 900;
}
.doctor-container .middle .box:active {
  transform: translateY(10px);
}
.doctor-container .middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  transition: all 300ms ease;
  font-size: 1.5em;
  -webkit-user-select: none;
          user-select: none;
  color: #007e90;
}
.doctor-container .middle .box span:before {
  font-size: 1.2em;
  font-family: FontAwesome;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: white;
}
.doctor-container .middle .front-end span:before {
  content: "\\f0f0";
}
.doctor-container .middle .back-end span:before {
  content: "\\f0f0";
}
.doctor-container .middle p {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.doctor-container .middle p a {
  text-decoration: underline;
  font-weight: bold;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/requestTracking/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;EACjC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;;;;;EAKE,OAAO;AACT;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;EAEE,QAAQ;AACV;;AAEA,uEAAuE;AACvE;;;GAGG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,4BAA4B;EAC5B,UAAU;EACV,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".table-content.request-track-table .searchDate .date-range input {\r\n  padding: 6px 10px;\r\n  border: 1px solid lightgray;\r\n  border-radius: 3px;\r\n  width: 140px;\r\n}\r\n\r\n.react-datepicker-wrapper {\r\n  width: auto;\r\n}\r\n\r\n/* Fix calendar transparency and visibility */\r\n.react-datepicker {\r\n  background-color: #fff !important;\r\n  border: 1px solid #aeaeae !important;\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: #f0f0f0 !important;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.table-content.request-track-table\r\n  .request-table-content\r\n  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,\r\n.request-box-info\r\n  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\r\n  width: 0px;\r\n}\r\n\r\n.table-content.request-track-table\r\n  .request-table-content\r\n  .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-inputSizeSmall.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,\r\n.request-box-info\r\n  .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-inputSizeSmall.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\r\n  opacity: 0;\r\n}\r\n\r\n.table-content.request-track-table\r\n  .request-table-content\r\n  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon,\r\n.request-box-info\r\n  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\r\n  left: 0;\r\n}\r\n\r\n.table-content.request-track-table\r\n  .request-table-content\r\n  .MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline,\r\n.request-box-info\r\n  .MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {\r\n  border: none;\r\n}\r\n\r\n.request-box-info\r\n  .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\r\n  top: 5px;\r\n}\r\n\r\n/* @import url(\"https://fonts.googleapis.com/css?family=Inter:400'\"); */\r\n/* html {\r\n  background-color: #1a1a1a;\r\n  overflow: hidden;\r\n} */\r\n\r\n.doctor-container .middle {\r\n  width: 100%;\r\n  text-align: center;\r\n  /* Made by */\r\n}\r\n.doctor-container .middle h1 {\r\n  font-family: \"Inter\", sans-serif;\r\n  color: #fff;\r\n}\r\n.doctor-container .middle input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n.doctor-container .middle input[type=\"radio\"]:checked + .box {\r\n  background-color: #007e90;\r\n}\r\n.doctor-container .middle input[type=\"radio\"]:checked + .box span {\r\n  color: white;\r\n  transform: translateY(70px);\r\n}\r\n.doctor-container .middle input[type=\"radio\"]:checked + .box span:before {\r\n  transform: translateY(0px);\r\n  opacity: 1;\r\n}\r\n.doctor-container .middle .box {\r\n  width: 200px;\r\n  height: 200px;\r\n  background-color: #fff;\r\n  transition: all 250ms ease;\r\n  will-change: transition;\r\n  display: inline-block;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  font-family: \"Inter\", sans-serif;\r\n  font-weight: 900;\r\n}\r\n.doctor-container .middle .box:active {\r\n  transform: translateY(10px);\r\n}\r\n.doctor-container .middle .box span {\r\n  position: absolute;\r\n  transform: translate(0, 60px);\r\n  left: 0;\r\n  right: 0;\r\n  transition: all 300ms ease;\r\n  font-size: 1.5em;\r\n  user-select: none;\r\n  color: #007e90;\r\n}\r\n.doctor-container .middle .box span:before {\r\n  font-size: 1.2em;\r\n  font-family: FontAwesome;\r\n  display: block;\r\n  transform: translateY(-80px);\r\n  opacity: 0;\r\n  transition: all 300ms ease-in-out;\r\n  font-weight: normal;\r\n  color: white;\r\n}\r\n.doctor-container .middle .front-end span:before {\r\n  content: \"\\f0f0\";\r\n}\r\n.doctor-container .middle .back-end span:before {\r\n  content: \"\\f0f0\";\r\n}\r\n.doctor-container .middle p {\r\n  color: #fff;\r\n  font-family: \"Inter\", sans-serif;\r\n  font-weight: 400;\r\n}\r\n.doctor-container .middle p a {\r\n  text-decoration: underline;\r\n  font-weight: bold;\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
